import {API_URL} from "../../dev";
import "isomorphic-fetch";

class AccessCodesApi {
	async lookupPriceLevel(eventUuid, accessCode) {
		try {
			const response = await fetch(
				`${API_URL}/v1/accesscodes/pricelevel/${eventUuid}?code=${accessCode}`);
			const responseObj = await response.json();
			if (response.ok) {
				return responseObj;
			}
			throw responseObj;
		} catch (e) {
			console.error(`Error occurred in lookupPriceLevel: ${JSON.stringify(e)}`);
			throw e;
		}
	}
}
const accessCodesApi = new AccessCodesApi();
export default accessCodesApi;
